// This file was auto-generated by Fern from our API Definition.
import * as FernIr from "../../../../../index.mjs";
export const OutputMode = {
    publish: (value) => {
        return Object.assign(Object.assign({}, value), { type: "publish", _visit: function (visitor) {
                return FernIr.generatorExec.OutputMode._visit(this, visitor);
            } });
    },
    downloadFiles: () => {
        return {
            type: "downloadFiles",
            _visit: function (visitor) {
                return FernIr.generatorExec.OutputMode._visit(this, visitor);
            },
        };
    },
    github: (value) => {
        return Object.assign(Object.assign({}, value), { type: "github", _visit: function (visitor) {
                return FernIr.generatorExec.OutputMode._visit(this, visitor);
            } });
    },
    _visit: (value, visitor) => {
        switch (value.type) {
            case "publish":
                return visitor.publish(value);
            case "downloadFiles":
                return visitor.downloadFiles();
            case "github":
                return visitor.github(value);
            default:
                return visitor._other(value);
        }
    },
};
